export default __webpack_public_path__ + "static/media/customer-shade-icon-green.7687b65f.svg";